import classnames from 'classnames';
import React from 'react';

export const InputCharCount = ({
  count,
  maxCount,
}: {
  count: number;
  maxCount: number;
}) => {
  return (
    <span
      className={classnames(
        'pr-4 text-sm',
        count > maxCount ? 'text-icon-error' : 'text-inherit',
      )}
    >
      {count}/{maxCount}
    </span>
  );
};
